import './Modal.scss'
import { Dialog, DialogTitle, DialogContent, DialogActions, ClickAwayListener } from '@mui/material'
import Button from '../button/Button'

const Modal = ({ open, title, children, handleSaveNow, handleClose }) => {
  return (
    <Dialog open={open} onClose={handleClose} className='model-dialog'>
      <ClickAwayListener onClickAway={handleClose}>
        <div className='modal-main-wrapper'>
          <DialogTitle sx={{ fontWeight: 'bold' }} className='dialog-title' id='alert-dialog-title'>
            {title}
          </DialogTitle>
          <DialogContent>{children}</DialogContent>
          <DialogActions className='btn-div'>
            <div className='model-buttons'>
              <Button variant='outlined' customClassName='btn-cancel' onClick={handleClose}>
                Cancel
              </Button>
              <Button type='button' customClassName='btn-save' onClick={handleSaveNow}>
                Save Now
              </Button>
            </div>
          </DialogActions>
        </div>
      </ClickAwayListener>
    </Dialog>
  )
}

export default Modal
